import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { PickedAndPackedResponse } from 'src/app/wings-mobile/models/picked-and-packed/picked-and-packed-response.model';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PackingService } from 'src/app/wings-mobile/services/outbound/packing/packing.service';
import { InputFields } from "../../../../models/inputs/input-fields.model";
import { SearchPrintResponse } from "../../../../models/picked-and-packed/search-print-response.model";
import { SearchPrintRequest } from "../../../../models/picked-and-packed/search-print-request.model";
import { PackedCreateBoxResponse } from "../../../../models/picked-and-packed/packed-create-box-response.model";
import { CaseStatus } from "../../../../shared/constants/case-status";
import { PackingSaveRequest } from "../../../../models/picked-and-packed/packing-save-request.model";
import { DispatchingInvoicingService } from "../../../../services/outbound/dispatching-invoicing.service";
import { WorkOrderItemDetailStatus as w352status } from "../../../../shared/constants/workorder-item-detail-status";
import { BinToBulkRequest } from "../../../../models/picked-and-packed/bin-to-bulk-request";
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { AlertCustomComponent } from '../../../../shared/alert-custom/alert-custom.component';
import { InputGenericComponent } from '../../../../shared/input-generic/input-generic.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'packing',
    templateUrl: './packing.component.html',
    styleUrls: ['./packing.component.scss'],
    providers: [ConfirmationService, MessageService],
    imports: [FormsModule, InputTextModule, NgClass, NgIf, ButtonDirective, AlertCustomComponent, InputGenericComponent, ConfirmDialogModule, ToastModule, TranslatePipe]
})
export class PackingComponent implements OnInit {

	showInfo: boolean;
	labelBoxIsOk: boolean;
	oldCaseUid: number;

	packing: PickedAndPackedResponse;
	createBoxResponse: PackedCreateBoxResponse;
	searchPrintRequest: SearchPrintRequest;
	searchPrintResponse: SearchPrintResponse;

	errorTitle: string;
	errorMessage: string;
	errorFocus: string;
	showAlert: boolean;

	inputFields: InputFields[];

	constructor(
		public messageBeep: MessageBeep,
		private translate: TranslateService,
		private packingService: PackingService,
		private globals: Globals,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private renderer: Renderer2,
		private dispAndInvService: DispatchingInvoicingService
	) {
		this.globals = globals;
		this.packingService = packingService;
		this.messageBeep = messageBeep;
		this.translate = translate;
		this.confirmationService = confirmationService;
		this.messageService = messageService;
		this.renderer = renderer;
		this.inputFields = [
			{ name: 'pack_label', id: 'pack_label', focus: true, value: null, action: 'this.findByLabel()' },
			{ name: 'pack_box', id: 'pack_box', focus: false, value: null, action: 'this.checkBox()' },
			{ name: 'pack_box_quantity', id: 'pack_box_quantity', focus: false, value: null, action: '' }
		];
	}

	ngOnInit() {
		this.renderer.selectRootElement('#scanner_id').focus();
		this.showInfo = false;
		this.showAlert = false;
		this.labelBoxIsOk = false;
	}

	// ==================
	// PICKING LABEL
	// ==================

	findByLabel() {
		this.packingService.getPacking(this.inputFields[0].value, this.globals.user.warehouse.bkSubDivisionUidD)
			.subscribe(packingR => {
				if (!packingR || packingR.length == 0) {
					this.showInfo = false;
					this.inputFields[0].value = null;
					this.showErrorModal('modal.error', 'modal.labelNotFound', 'pack_label');
				} else {
					if (packingR[0].whXLocation.locationType.bulkTypeF == "Y"
						&& (packingR[0].workOrderItems.transactionTypeF == null
							|| packingR[0].workOrderItems.transactionTypeF == "F")) {
						this.showInfo = false;
						this.inputFields[0].value = null;
						this.showErrorModal('Error', 'modal.labelBulkNotPermited', 'pack_label');
					} else {
						if (packingR[0].status.bkStatusR === w352status.picked) {
							this.showInfo = true;
							this.packing = packingR[0];
							this.inputFields[2].value = packingR[0].partQ;
							this.labelBoxIsOk = true;
							this.inputFields[1].value = null;
							setTimeout(() => this.focusInputFields('pack_box'), 100);
						} else {
							this.resetAllFields();
							switch (packingR[0].status.bkStatusR) {
								case CaseStatus.printed:
									this.showErrorModal('modal.error', 'modal.LabelNotPicked', 'pack_label');
									break;
								case CaseStatus.packed:
									this.showErrorModal('modal.error', 'modal.LabelIsAlreadyPacked', 'pack_label');
									break;
								default:
									this.showErrorModal('modal.error', 'modal.LabelIsAlreadyPacked', 'pack_label');
							}
						}
					}
				}
			});
	}

	// ==================
	// PACKING LABEL
	// ==================

	changePartQ(): Boolean {
		if (this.inputFields[2].value) {
			this.focusInputFields('pack_box');
			return true;
		} else {
			this.showErrorModal("Error", this.translate.instant('modal.qttyNotEmpty'), 'pack_box_quantity');
			this.focusInputFields('pack_box_quantity');
			return false;
		}
	}

	checkBox(): void {
		if (this.packing && this.packing.outboundCases.bkCaseR === this.inputFields[1].value && this.inputFields[2].value) {
			this.savePacking();
		} else {
			if (this.changePartQ()) {
				this.checkCustomerBox();
			} else {
				this.focusInputFields('pack_box_quantity');
			}
		}
	}

	savePacking() {
		this.packingService.savePacking(this.setSavePackingRequest())
			.subscribe({
				next: () => {
					this.resetAllFields();
					this.messageBeep.successBeep();
				},
				error: error => {
					if (error.error != null) {
						if (error.error.exceptionMessage == "application.outbound.pickedandpacked.failure.qttyNotMultipleOfUnityOfIssue") {
							this.showErrorModal("Error", this.translate.instant('modal.qttyNotMultipleOfUnityOfIssue'), 'pack_box');

						} else {
							this.showErrorModal("Error", error.error.exceptionMessage, 'pack_box');
						}
					} else {
						this.showErrorModal("Error", 'modal.connectionFailed', 'pack_box');
					}
				}
			}).add(() => this.oldCaseUid = null) // executes after next and error
	}

	setSavePackingRequest() {
		const request = new PackingSaveRequest();

		request.workOrderItemDetailUidK = this.packing.workOrderItemDetailUidK;
		request.bkWorkOrderItemUidD = this.packing.workOrderItems.workOrderItemUidK;
		request.statusUidD = this.packing.status.bkStatusR;
		request.partSubDivisionUidD = this.globals.user.warehouse.bkSubDivisionUidD;
		request.warehouseUidD = this.packing.warehouseUidD;
		request.partQ = this.inputFields[2].value;
		request.outboundCaseUidD = this.oldCaseUid ? this.oldCaseUid : this.packing.outboundCaseUidD;
		request.outboundBatchControlUidD = this.packing.outboundBatchControlUidD;
		request.pickingLabelR = this.packing.pickingLabelR;
		request.outboundCases.subDivisionUidD = this.globals.user.warehouse.bkSubDivisionUidD;
		request.outboundCases.bkCaseR = this.inputFields[1].value
		return request
	}

	checkCustomerBox() {
		this.packingService.boxByCustomer(
			this.globals.user.warehouse.bkSubDivisionUidD,
			this.inputFields[1].value,
			this.packing.workOrderItems.customers.customerUidK,
			this.packing.outboundBatchControlUidD).subscribe({
				next: res => {
					if (res) {
						this.oldCaseUid = res.outboundCaseUidD;
						this.checkCase();
					} else {
						this.resetOnBoxFieldError();
						this.showErrorModal("modal.error", 'modal.customerBoxError', 'pack_box');
					}
				},
				error: () => {
					this.resetOnBoxFieldError();
					this.showErrorModal("modal.error", 'modal.operationNotPerformed', 'pack_box');
				}
			})
	}

	checkCase() {
		this.dispAndInvService.getBox(this.inputFields[1].value, this.globals.user.warehouse.bkSubDivisionUidD).subscribe({
			next: res => {
				if (res && res.length !== 0 && this.isBoxStatusValid(res[0].outboundCasesTO.statusTO.bkStatusR)) {
					this.savePacking();
				} else {
					this.resetOnBoxFieldError();
					this.showErrorModal("modal.error", 'modal.invalidBoxStatus', 'pack_box');
				}
			},
			error: () => {
				this.resetOnBoxFieldError();
				this.showErrorModal("modal.error", 'modal.operationNotPerformed', 'pack_box');
			}
		});
	}

	// Case(Box) Status that allow packing save
	isBoxStatusValid(statusR: number) {
		return (statusR === CaseStatus.printed ||
			statusR === CaseStatus.packed ||
			statusR === CaseStatus.dispatch);
	}

	// ==============
	// CREATE BOX
	// ==============
	newBox() {
		if (this.labelBoxIsOk && this.packing) {
			this.searchPrint();
			this.confirmationService.confirm({
				message: this.translate.instant('modal.newTypeBox') + this.packing.outboundCases.bkCaseR,
				header: this.translate.instant('modal.confirmation'),
				icon: 'pi pi-exclamation-triangle',

				accept: () => {
					this.packingService.newBox(this.packing.outboundCases.bkCaseR, this.globals.user.warehouse.bkSubDivisionUidD, this.searchPrintResponse.hostN, this.searchPrintResponse.portC)
						.subscribe({
							next: res => {
								this.createBoxResponse = res;
								this.messageBeep.successBeep();
								this.messageService.add({
									key: 'tc',
									severity: 'success',
									summary: this.translate.instant('message.success'),
									detail: this.translate.instant('modal.accepted')
								});
								this.resetAllFields();
							},
							error: error => {
								if (typeof error.error !== 'string') {
									this.showErrorModal("Error", 'modal.connectionFailed', 'pack_label');
								} else {
									this.showErrorModal("Error", error.error, 'pack_label');
								}
							}
						});
				},
				reject: () => {
					this.inputFields[1].value = null;
					this.messageService.add({ key: 'tc', severity: 'error', summary: 'error', detail: this.translate.instant('modal.rejected') });
					this.focusInputFields('pack_box');
				}
			});
		}
	}

	async searchPrint() {
		this.searchPrintRequest = {
			"bkCdsidC": this.globals.user.userName,
			"printerConfig": {
				"printerTypeC": "ZEBRA",
				"subDivisionUidD": this.globals.user.warehouse.bkSubDivisionUidD,
				"documentType": {
					"bkDocumentTypeC": "BOX",
				},
				"warehouse": {
					"warehouseUidK": this.globals.user.warehouse.warehouseUidK,
					"bkSubDivisionUidD": this.globals.user.warehouse.bkSubDivisionUidD,
					"buildingCodeC": this.globals.user.warehouse.buildingCodeC,
				}
			}
		};
		this.packingService.searchToPrint(this.searchPrintRequest).subscribe({
			next: res => {
				this.searchPrintResponse = res[0];
			},
			error: error => {
				if (error.error != null) {
					this.showErrorModal("Error", error.error.exceptionMessage, 'pack_box');
				} else {
					this.showErrorModal("Error", 'modal.connectionFailed', 'pack_box');
				}
			}
		});
	}

	// =====================
	//	BIN TO BULK
	// =====================

	binToBulkConfirmation() {
		this.confirmationService.confirm({
			message: this.setConfirmationMessage(),
			header: this.translate.instant('modal.confirmation'),
			icon: 'pi pi-exclamation-triangle',
			acceptLabel: this.translate.instant('modal.yes'),
			rejectLabel: this.translate.instant('modal.no'),
			accept: () => {
				this.binToBulk();
			},
			reject: () => {
				this.focusInputFields('pack_label');
			}
		});
	}

	setConfirmationMessage(): string {
		return this.translate.instant('message.binBulkConfirmation') +
			this.packing.pickingLabelR + this.translate.instant('message.fromBinToBulk');
	}

	binToBulk() {
		this.packingService.binToBulk(this.setBinToBulkRequest()).subscribe({
			next: () => {
				this.messageService.add({
					key: 'tc',
					severity: 'success',
					summary: this.translate.instant('message.success'),
					detail: this.translate.instant('message.binToBulkSuccess')
				});
			},
			error: e => {
				if (e.error != null) {
					this.showErrorModal("Error", e.error.exceptionMessage, 'pack_label');
				} else {
					this.showErrorModal("Error", 'modal.connectionFailed', 'pack_label');
				}
			}
		}).add(() => this.resetAllFields());
	}

	setBinToBulkRequest(): BinToBulkRequest {
		let binToBulkRequest = new BinToBulkRequest();

		binToBulkRequest.pickingLabelR = this.packing.pickingLabelR;
		binToBulkRequest.outboundCases.subDivisionUidD = this.globals.user.warehouse.bkSubDivisionUidD;

		return binToBulkRequest;
	}

	// =====================
	//	HELPER METHODS
	// =====================

	resetAllFields() {
		this.showInfo = false;
		this.inputFields[0].value = null;
		this.inputFields[1].value = null;
		this.inputFields[2].value = null;
		this.packing = null;
		this.oldCaseUid = null;
		this.labelBoxIsOk = false;
		this.focusInputFields("pack_label")
	}

	resetSomeFields() {
		this.showInfo = false;
		this.oldCaseUid = null;
		this.inputFields[1].value = null;
		this.inputFields[2].value = null;
	}

	resetOnBoxFieldError() {
		this.oldCaseUid = null;
	}

	// ERROR MODAL METHODS

	showErrorModal(title: string, msg: string, focus?: string) {
		this.errorTitle = this.translate.instant(title);
		this.errorMessage = this.translate.instant(msg);
		this.errorFocus = focus;
		this.showAlert = true;
		this.messageBeep.errorBeep();
	}

	hideErrorModal(elId: string) {
		if (elId) {
			this.focusInputFields(elId);
		}
		this.inputFields.forEach(item => {
			if (item.id === elId) {
				item.value = null;
			}
		});
		this.showAlert = false;
	}

	executeAction(item) {
		eval(item.action);
	}

	//	FOCUS METHODS

	focusInputFields(elId: string) {
		this.blurInputFields();
		this.renderer.selectRootElement('#scanner_id').focus();
		switch (elId) {
			case 'pack_label':
				this.inputFields[0].focus = true;
				break;
			case 'pack_box':
				this.inputFields[1].focus = true;
				break;
			case 'pack_box_quantity':
				this.inputFields[2].focus = true;
				break;
			default:
				break;
		}
	}

	blurInputFields() {
		this.inputFields.forEach(input => input.focus = false);
	}

	onInsertUnit(event) {
		if (event.key === '.' || event.key === '-' || event.key === '+' || event.key === 'e') {
			event.preventDefault();
		}
	}
}

